import { render, staticRenderFns } from "./Pagamento.vue?vue&type=template&id=9671cf0e&scoped=true&"
import script from "./Pagamento.vue?vue&type=script&lang=js&"
export * from "./Pagamento.vue?vue&type=script&lang=js&"
import style0 from "./Pagamento.vue?vue&type=style&index=0&id=9671cf0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9671cf0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9671cf0e')) {
      api.createRecord('9671cf0e', component.options)
    } else {
      api.reload('9671cf0e', component.options)
    }
    module.hot.accept("./Pagamento.vue?vue&type=template&id=9671cf0e&scoped=true&", function () {
      api.rerender('9671cf0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/steps/Pagamento.vue"
export default component.exports